import { render, staticRenderFns } from "./UpgradeList.vue?vue&type=template&id=e502ef70&scoped=true"
import script from "./UpgradeList.vue?vue&type=script&lang=js"
export * from "./UpgradeList.vue?vue&type=script&lang=js"
import style0 from "./UpgradeList.vue?vue&type=style&index=0&id=e502ef70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e502ef70",
  null
  
)

export default component.exports